import { HLS_KR, HLS, SS } from '../../utils/playerConstants';
import deviceInfo from '../all/deviceInfo';


const multipleaudio = {};
// HLS_KR
multipleaudio.hls_kr = {};
multipleaudio.hls_kr.vod = false;
multipleaudio.hls_kr.live = false;
multipleaudio.hls_kr.timeshift = false;
// HLS
multipleaudio.hls = {};
multipleaudio.hls.vod = false;
multipleaudio.hls.live = false;
multipleaudio.hls.timeshift = false;
// SS
multipleaudio.smooth_streaming = {};
multipleaudio.smooth_streaming.vod = true;
multipleaudio.smooth_streaming.live = false;
multipleaudio.smooth_streaming.timeshift = false;

// Put only SINGLE streams here
const supported_stream_types = {};
// in priority order, first has a major priority
supported_stream_types.vod = [SS, HLS];
supported_stream_types.live = [HLS_KR, HLS];
supported_stream_types.timeshift = [HLS_KR, HLS];

export default {
  appKey: '0cc2563716655c470cb5c2a108fb89e6', // TODO ESTO ES DE NAGRA
  appSubkey: 'netrange' || 'netrangemmh',
  // Request params
  device_category: 'tv',
  /* device_id:"nousar", */
  device_manufacturer: 'netrange' || 'netrangemmh',
  device_model: 'generic',
  device_name: 'netrange' || 'netrangemmh',
  device_so: deviceInfo.os.description || 'android',
  device_type: 'tv',
  stream_type: 'smooth_streaming',
  // multipleaudio: multipleaudio, //Estos valores ahora se toman de la llave supported_stream de METADATA
  // supported_stream_types: supported_stream_types, //Estos valores ahora se toman de la llave supported_stream de METADATA
  akamai_id: 'HisenseSTV',
  useEpgPostals: true,
  // akamai_mfwk: 'mfwktv2-api.clarovideo.net',
  akamai_mfwk: (window.location && window.location.protocol) ? window.location.protocol + '//' + 'mfwktv2-api.clarovideo.net' : 'http://mfwktv2-api.clarovideo.net'
};



// WEBPACK FOOTER //
// ./src/devices/netrange/config.js